import React from 'react'
import cx from 'classnames'

import { useAmazonPayButton } from 'modules/payment'

import { Icon, Text } from 'components/dataDisplay'
import { buttonMessages } from 'components/inputs'

import AmazonWidgetsModal from '../AmazonWidgetsModal/AmazonWidgetsModal'
import ExpressCheckoutButton from '../ExpressCheckoutButton/ExpressCheckoutButton'

import s from './AmazonPayButton.module.css'


type AmazonPayButtonProps = {
  className?: string
}

const AmazonPayButton: React.FunctionComponent<AmazonPayButtonProps> = (props) => {
  const { className } = props
  const { buttonId, clientId, isFetching, isLoaded, isProcessing } = useAmazonPayButton()

  return (
    <>
      <ExpressCheckoutButton
        className={cx(s.button, className, 'relative')}
        id={buttonId}
        loading={isFetching}
        disabled={!isLoaded || isProcessing}
        key={clientId} // It's needed to reinit amazon script button to use a correct clientId (EP-1369)
        data-testid="amazonPayButton"
      >
        {
          isFetching ? (
            <Text
              message={buttonMessages.loading}
              style="t4"
              color="black"
            />
          ) : (
            <Icon
              className="pt-8"
              name="other/amazon"
              isInline
            />
          )
        }
      </ExpressCheckoutButton>
      <AmazonWidgetsModal />
    </>
  )
}


export default AmazonPayButton
